<template>
	<page>
		<module>
			<view-list :work-type="workType" ref="view" selector :view-config="auth('b_inventory_viewmanage')">
				<template #search>
					<m-search ref="search">
						<m-search-item label="单据编号">
							<c-input name="order_code"></c-input>
						</m-search-item>
						<m-search-item label="备注">
							<c-input name="remark"></c-input>
						</m-search-item>
						<m-search-item label="业务分类" width="200">
							<c-select name="order_classify" async multiple @search="searchOrderClassify"></c-select>
						</m-search-item>
						<m-search-item label="盘点时间" colspan="2">
							<c-datetime range start-name="start_date" end-name="end_date"></c-datetime>
						</m-search-item>
					</m-search>
				</template>

				<template #operate>
					<c-button color="main" v-if="auth('b_inventory_create')" v-lock="lock('b_inventory_create')" prepend-icon="tf-add" @click="$refs.inventoryEdit.open()">创建盘点单</c-button>
					<c-button v-if="auth('b_inventory_export')" v-lock="lock('b_inventory_export')" prepend-icon="tf-export" @click="$refs.view.exportListByViewId()">导出</c-button>
					<c-button v-if="auth('b_inventory_export')" v-lock="lock('b_inventory_export')" prepend-icon="tf-export" @click="$refs.view.exportListByViewId(3)">按模板导出</c-button>
					<c-button  prepend-icon="tf-import" @click="importData()">导入</c-button>
				</template>
				
				<template #batchOperate="{data}">
					<c-button v-if="auth('b_inventory_export')" v-lock="lock('b_inventory_export')" prepend-icon="tf-export" @click="$refs.view.exportListByViewId()">导出</c-button>
					<c-button v-if="auth('b_inventory_export')" v-lock="lock('b_inventory_export')" prepend-icon="tf-export" @click="$refs.view.exportListByViewId(3)">按模板导出</c-button>
					<c-button v-if="auth('b_inventory_print')" v-lock="lock('b_inventory_print')" prepend-icon="tf-print" @click="$refs.view.batchExportByTemplate()">打印</c-button>
				</template>

				<template #otherOperate>
					<c-button prepend-icon="tf-import-record" @click="loadImportLogDetail()">导入记录</c-button>
				</template>

				<template #order_code="{data}">
					<c-link @click="globalDialog('inventoryDetail', {props: {id: data.id}})">{{data.order_code}}</c-link>
				</template>

				<!--【盘点】业务分类-->
				<template #order_classify="{data}">
					<c-state dict="inventoryClassifyName" :value="data.order_classify"></c-state>
				</template>
				<!--【盘点】备注-->
				<template #remark="{data}">
					<span v-if="data.remark">{{data.remark}}</span>
					<span v-else>-</span>
				</template>
                <!--审批状态-->
                <template #approve_state="{data}">
                    <c-state dict="approveStateDic" tag :value="data.approve_state"></c-state>
                </template>
                <!--审批时间-->
                <template #approve_date="{data}">
                    <span v-if="data.approve_date">{{data.approve_date}}</span>
                    <span v-else>-</span>
                </template>
                <!--审批人-->
                <template #approve_user_realname="{data}">
                    <span v-if="data.approve_user_realname">{{data.approve_user_realname}}</span>
                    <span v-else>-</span>
                </template>

				<c-table-column
					type="button"
					label="操作"
					width="180"
					button-limit="3"
				>
					<template #default="{data}">
                        <c-table-button v-if="auth('b_inventory_edit')" v-lock="lock('b_inventory_edit')" :disabled="!(data.approve_state == 1)" icon="tf-edit" @click="$refs.inventoryEdit.open(data)">编辑</c-table-button>
						<c-table-button icon="tf-detail" @click="globalDialog('inventoryDetail', {props: {id: data.id}})">查看</c-table-button>
                        <c-table-button v-if="auth('b_inventory_approve')" v-lock="lock('b_inventory_approve')" :disabled="!(data.approve_state == 1)" icon="tf-approve" @click="approve(data)">审批</c-table-button>
                        <c-table-button v-if="auth('b_inventory_approve')" v-lock="lock('b_inventory_approve')" :disabled="!(data.approve_state == 2)" icon="tf-recall" @click="cancelApprove(data)">撤回</c-table-button>
                        <c-table-button v-if="auth('b_inventory_print')" v-lock="lock('b_inventory_print')" icon="tf-print" @click="$refs.view.exportByTemplate(data.id,view_id)">打印</c-table-button>
						<c-table-button v-if="auth('b_inventory_delete')" v-lock="lock('b_inventory_delete')" icon="tf-trash" color="red" @click="remove(data)">删除</c-table-button>
					</template>
				</c-table-column>
			</view-list>
			<!--创建、编辑盘点单信息弹窗-->
			<inventory-edit ref="inventoryEdit" @resolve="$refs.view.update()"></inventory-edit>
		</module>
	</page>
</template>

<script>
	import inventoryEdit from "@/pages/storage/inventory_edit.vue";

	export default {
		components: {inventoryEdit},
		data() {
			return {
				workType: 6,
				view_id: 10007
			}
		},
		methods: {
			/*******搜索角色*****************/
			searchOrderClassify(keyword, resolve){
				this.request({
					url:'/system/native/options',
					data: {
						options_code:'INVENTORY_CLASSIFY'
					},
					success:data => {
						resolve(data);
					}
				})
			},

			/******删除***********/
			remove(data){
				this.$confirm({
					message:'确认删除盘点单【'+data.order_code+'】？删除后不可恢复',  // 提示内容,
					buttonName: '确定',  // 确定按钮文字
					cancelButton: true,  // 是否显示取消按钮
					resolve: () => {
						this.request({
							url: '/inventory/order/remove',
							data: {id:data.id},
							loading: true,
							success: data => {
								this.$message({
									message:'删除成功',  // 提示内容,
									type: 'success'
								});
								this.$refs.view.refresh();
							}
						});
					},  // 确定按钮回调
					cancel: () => {},  // 取消按钮回调
				});
			},

            /******审批***********/
            approve(data){
                this.request({
                    url: '/inventory/order/approve',
                    data: {id:data.id},
                    loading: true,
                    success: data => {
                        this.$message({
                            message:'审批成功',  // 提示内容,
                            type: 'success'
                        });
                        this.$refs.view.refresh();
                    }
                });
            },

            /******撤销审批***********/
            cancelApprove(data){
                this.$confirm({
                    message:'撤回后入库单【'+data.order_code+'】将回滚至待审批状态，相应的库存调整也将回滚，是否确认撤回？',  // 提示内容,
                    buttonName: '确定',  // 确定按钮文字
                    cancelButton: true,  // 是否显示取消按钮
                    resolve: () => {
                        this.request({
                            url: '/inventory/order/cancel',
                            data: {id:data.id},
                            loading: true,
                            success: data => {
                                this.$message({
                                    message:'撤回成功',  // 提示内容,
                                    type: 'success'
                                });
                                this.$refs.view.refresh();
                            }
                        });
                    },  // 确定按钮回调
                    cancel: () => {},  // 取消按钮回调
                });
            },

			/******选择仓库等响应方法*********/
			warehouseSelectorHandle(data) {
				this.$refs.view.excelImport(Object.assign(data, {
					view_id: this.view_id,
					title: '批量导入【盘点单】数据' + (data.warehouse_name ? '（'+data.warehouse_name+'）' : '')
				}));
			},

			/*******导入数据************/
			importData() {
				this.globalDialog('storageInfoSelector',{
					props: {
						workType: this.workType,
						title: '盘点'
					}
				}, this.warehouseSelectorHandle);
			},

			/******加载导入业务日志列表**********/
			loadImportLogDetail() {
				//打开模板选择弹窗
				this.globalDialog('importLogDetail',{
					props: {
						workType: this.workType,
						view_id: this.view_id
					}
				});
			}
		}
	}
</script>

<style lang="stylus" scoped>
</style>